export default {
    // *****字符判断
    noVal(val,arg){  //不能为空值
        if(val && val.length != 0){
            return false;
        }
        return arg?`${arg}不能为空`:"该项不能为空";
    },
    noName(val){  //任务名称不能为空
        if(val){
            return false;
        }
        return "请输入任务名称"
    },
    reason(val,arg){  //申请理由什么的
        if(val){
            return false;
        }
        return "请填写"+arg;
    },
    choose(val,arg){   //DIY的列表选择
        if(!val){
            return "请选择"+arg;
        }
        return false;
    },
    limit(val,arg){   //字符数限制
        let min = arg[0];
        let max = arg[1];
        if(val.trim() == "" || val.length == 0){
            return "该项不能为空"
        }

        if(val.indexOf(" ") == -1){
            let len = val.length;
            if(len<min){
                return `至少包含${min}个字符`
            }else if(len>max){
                return `不得大于${max}个字符`
            }else{
                return false;
            }
        }else{
            return "不能包含空格"
        }
    },
    describe_limit(val){  //文字描述字数限制
        if(val.length>125){
            return "文字描述不得超过125个字符"
        }
        return false;
    },

    scope(val){  //两个选框
        if(val && val.length != 0){
            return false;
        }
        return "范围需填写完整"
    },
    checkgroup(val,arg){  //多选框不能为空
        if(val && val.length != 0){
            return false;
        }
        return "请选择至少一个选项"
    },

    // ****数字类型
    number(val){  //数字类型 整数
        if(isNaN (val - 0) || parseInt(val) != val){
            return "请输入正确整数";
        }
        return false;
    },
    positive(val){  //非负数
        if(isNaN (val - 0) || val<0 ){
            return "请输入非负数"
        }
        return false;
    },
    integer(val){  //正整数
        if(isNaN (val - 0) || parseInt(val) != val || val<=0){
            return "请输入一个正整数";
        }
        return false;
    },

    range(val,arr){  //数字类型，要求范围之内 
        let range = arr[0];
        let text = arr[1];

        if(val==""){
            return `请输入${text}`
        }
        
        if(isNaN (val - 0)){
            return "请输入数字";
        }

        if(val - range[0]<0 || val - range[1]>0){
            return `请输入正确${text}`
        }

        return false;
    },
    bonus(val){  //正整数 没有报错信息  用于奖金分配处
        if(val === "" || isNaN (val - 0) || parseInt(val) != val || val<0){
            return " ";
        }
        return false;
    },
    cycle_day(val,arg){  //正整数 用于设置天数
        if(val && val>0 && val<=arg){
            return false;
        }
        if(val<=0){
            return "请输入一个正整数"
        }
        return `该数值不得大于${arg}`;
    },
    noTip_number(val){  //数字类型 整数 notip
        if(isNaN (val - 0) || parseInt(val) != val){
            return "";
        }
        return false;
    },



    // *****特殊格式
    phone(val){   //手机号码
        let res = /^[1][3,4,5,7,8][0-9]{9}$/.test(val);
        if(res){
            return false;
        }
        return "请输入正确的手机号码";
    },
    rate(val){   // 汇率规则
        let num = val.toString().split(".")[1];
        if(val && isNaN(val) == false && val>=0 && (!num || num.length<=2) ){
            return false;
        }
        return "";
    },


}


// WEBPACK FOOTER //
// ./src/config/rule-config.js